import { useState } from "react";
import { Link } from "react-router-dom";
import { HiExternalLink } from "react-icons/hi";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import { MODULES_LIST, SUB_MODULES_LIST } from "../../../../../utils/helper";
import useSubModulePermissionCheck from "../../../../../hooks/useSubModulePermissionCheck";

const cardData = [
  {
    title: "Manage Salary",
    detail: "Create or manage salary details for employees.",
    link: "/payroll/manage-salary",
    access: SUB_MODULES_LIST.PAYROLL.MANAGE_SALARY,
  },
  {
    title: "Payroll Attendance",
    detail: "Track and manage payroll attendance for employees.",
    link: "/payroll/payroll-attendance",
    access: SUB_MODULES_LIST.PAYROLL.MANAGE_SALARY,
  },
  {
    title: "Salary Reports",
    detail: "Generate detailed salary reports.",
    link: "/payroll/salary-report",
    access: SUB_MODULES_LIST.PAYROLL.MANAGE_SALARY_REPORT,
  },
  {
    title: "End of Service",
    detail: "Manage end-of-service benefits and settlements.",
    link: "/payroll/end-of-service",
    access: SUB_MODULES_LIST.PAYROLL.MANAGE_SALARY,
  },
];

const items = [
  { label: "Home", path: "/" },
  { label: "Payroll", path: "" },
];

const Payroll = () => {
  const _cardData = useSubModulePermissionCheck(cardData, MODULES_LIST.PAYROLL);

  return (
    <div className={"flex flex-col gap-2"}>
      <div className="flex flex-row justify-between items-center bg-white h-14">
        <PageTableHeader
          breadcrumbs={items}
          isSearch={false}
          isFilter={false}
          buttons={false}
        />
      </div>
      {_cardData && _cardData.length ? (
        <div
          className={
            "bg-white grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4"
          }
        >
          {_cardData.map((card, index) => (
            <Card
              key={index}
              title={card.title}
              detail={card.detail}
              link={card.link}
            />
          ))}
        </div>
      ) : 
      (<div>
      <NoDataFound />
      </div>)}
    </div>
  );
};

const Card = ({ title, detail, link }) => {
  const [active, setActive] = useState(false);

  const handleClick = () => {
    setActive(!active);
  };

  return (
    <div
      className={`flex flex-col justify-between bg-gray-50 p-3 hover:bg-white/10 rounded-md border`}
    >
      <div className={"flex justify-between items-start"}>
        <Link to={link} className={"flex flex-col gap-1"}>
          <span className={"text-sm font-bold text-theme"}>{title}</span>
          <span className={"text-xs text-textLight"}>{detail}</span>
        </Link>
      </div>

      {link && (
        <Link
          to={link}
          className={
            "text-xs text-theme mt-2 flex items-center gap-[2px] font-medium w-full"
          }
        >
          Show All
          <span className={"rounded-full flex justify-center items-center"}>
            <HiExternalLink className={"text-md text-theme"} />
          </span>
        </Link>
      )}
    </div>
  );
};

export default Payroll;
